import {useState} from "react";
import Spinner from "../../../Spinner";
import filterResponse from "../../../../filterResponse";
import useBackDrops from "../../../../hooks/useBackDrops";
import Error from "../../../Alerts/Error";

export default function DeleteEntryModal({entry, deleteEntry, loading, setLoading}) {
	useBackDrops();

	const [error, setError] = useState("");

	async function onClick() {
		setLoading(true);
		setError("");

		try {
			const response = await fetch(process.env.REACT_APP_ENDPOINT + '/crowdEntries/' + entry.id + '/delete', {
				method: "POST",
				credentials: "include"
			});
			await filterResponse(response);

			if (response.status === 204) {
				await deleteEntry(entry.id);
			}
			else {
				// A row only polls itself while QA is running, so a page left open never learns
				// that QA has accepted the entry since. Without this the Yes button would simply
				// do nothing and the entry would stay where it is, unexplained.
				const body = await response.json().catch(() => null);
				setError(body?.error || "This entry could not be deleted. Please reload the page and try again.");
			}
		}
		catch (e) {
			console.error("Failed to delete entry " + entry.id, e);
			setError("This entry could not be deleted. Please reload the page and try again.");
		}
		setLoading(false);
	}

	return (
		<>
			<div className="modal fade" id={`deleteEntryModal${entry.id}`} tabIndex="-1" aria-labelledby={`deleteEntryModalLabel${entry.id}`} aria-hidden="true">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<h1 className="modal-title fs-5" id={`deleteEntryModalLabel${entry.id}`}>Delete entry</h1>
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div className="modal-body">
							{error && <Error message={error} />}
							<p>Are you sure you want to delete this entry permanently? Please note this action is irreversible.</p>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
							<button type="button" onClick={onClick} className="btn btn-danger" disabled={loading}>{loading && <Spinner small={true} />} Yes</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
